const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  create ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/tb-dg/trade/refund/create', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  goodsPreview ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/tb-dg/trade/refund/goods-preview', {
      params,
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  searchRefundList ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/tb-dg/trade/refund/search-refund-list', {
      params,
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  cancel ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/tb-dg/trade/refund/cancel', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
